module.exports = __webpack_public_path__ + "b50043b58fa771e19811c692794ead51.pdf";